// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"454":"ac3ade33","507":"a85ce62e"}[chunkId] + ".css";
};